import { c as _c } from "react-compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import useFetchDesignViews from '@nike/shop-apis/customization/design_views/v1/use-query';
import ProductAddedModalContent from './ProductAddedModalContent';
import { ImageSkeleton, ProductAddedModalContentWrapper, ProductDetailsWrapper, SubtitleSkeleton, TitleSkeleton } from './styles';
var ProductCardSkeleton = function ProductCardSkeleton() {
  var $ = _c(2);
  var t0;
  if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/React.createElement(ImageSkeleton, null);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  var t1;
  if ($[1] === Symbol["for"]("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/React.createElement(ProductAddedModalContentWrapper, null, t0, /*#__PURE__*/React.createElement(ProductDetailsWrapper, null, /*#__PURE__*/React.createElement(TitleSkeleton, null), /*#__PURE__*/React.createElement(SubtitleSkeleton, null), /*#__PURE__*/React.createElement(SubtitleSkeleton, null)));
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
var ProductAddedModalCustomContent = function ProductAddedModalCustomContent(t0) {
  var $ = _c(5);
  var designViewId = t0.designViewId;
  var t1;
  if ($[0] !== designViewId) {
    t1 = {
      designViewId: designViewId,
      select: _temp
    };
    $[0] = designViewId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  var _useFetchDesignViews = useFetchDesignViews(t1),
    customImageURL = _useFetchDesignViews.data,
    isLoading = _useFetchDesignViews.isLoading,
    isSuccess = _useFetchDesignViews.isSuccess;
  if (isLoading) {
    var t2;
    if ($[2] === Symbol["for"]("react.memo_cache_sentinel")) {
      t2 = /*#__PURE__*/React.createElement(ProductCardSkeleton, null);
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  if (isSuccess) {
    var _t;
    if ($[3] !== customImageURL) {
      _t = /*#__PURE__*/React.createElement(ProductAddedModalContent, {
        customImageURL: customImageURL
      });
      $[3] = customImageURL;
      $[4] = _t;
    } else {
      _t = $[4];
    }
    return _t;
  }
  return null;
};
ProductAddedModalCustomContent.propTypes = {
  designViewId: PropTypes.string
};
export default ProductAddedModalCustomContent;
function _temp(t0) {
  var imageURL = t0.imageURL;
  return imageURL;
}